<template>
  <div ref="customerServiceInfo">
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <validation-observer ref="formRules">
        <form @submit.prevent="handleSubmit">
          <div class="m-2">
            <b-row>
              <b-col cols="12" md="4" class="mt-1"></b-col>
              <b-col cols="12" md="4" class="mt-1">
                <label class="text-sm"
                  >Old Password <span style="color: red">*</span></label
                >
                <validation-provider
                  #default="{ errors }"
                  name="Old Password"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      :type="show.old ? 'text' : 'password'"
                      v-model="form.old_password"
                      placeholder="Old Password"
                    />
                    <b-input-group-append
                      is-text
                      @click="show.old = !show.old"
                      style="cursor: pointer"
                    >
                      <feather-icon :icon="show.old ? 'EyeOffIcon' : 'EyeIcon'" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <span class="text-danger text-sm" v-if="be_errors['old_password']"
                  ><small>{{ be_errors["old_password"][0] }}</small></span
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4" class="mt-1"></b-col>
              <b-col cols="12" md="4" class="mt-1">
                <label class="text-sm"
                  >New Password <span style="color: red">*</span></label
                >
                <validation-provider
                  #default="{ errors }"
                  name="New Password"
                  rules="required"
                  vid="new_password"
                >
                  <b-input-group>
                    <b-form-input
                      :type="show.new ? 'text' : 'password'"
                      v-model="form.new_password"
                      placeholder="New Password"
                    />
                    <b-input-group-append
                      is-text
                      @click="show.new = !show.new"
                      style="cursor: pointer"
                    >
                      <feather-icon :icon="show.new ? 'EyeOffIcon' : 'EyeIcon'" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <span class="text-danger text-sm" v-if="be_errors['new_password']"
                  ><small>{{ be_errors["new_password"][0] }}</small></span
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4" class="mt-1"></b-col>
              <b-col cols="12" md="4" class="mt-1">
                <label class="text-sm"
                  >Confirm Password <span style="color: red">*</span></label
                >
                <validation-provider
                  #default="{ errors }"
                  name="Confirm Password"
                  rules="required|confirmed:new_password"
                  vid="confirm_password"
                >
                  <b-input-group>
                    <b-form-input
                      :type="show.confirm ? 'text' : 'password'"
                      v-model="form.confirm_password"
                      placeholder="Confirm Password"
                    />
                    <b-input-group-append
                      is-text
                      @click="show.confirm = !show.confirm"
                      style="cursor: pointer"
                    >
                      <feather-icon :icon="show.confirm ? 'EyeOffIcon' : 'EyeIcon'" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <span class="text-danger text-sm" v-if="be_errors['confirm_password']"
                  ><small>{{ be_errors["confirm_password"][0] }}</small></span
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4" class="mt-2"></b-col>
              <b-col cols="12" md="4" class="mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-1"
                  type="submit"
                >
                  Submit
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                  @click="resetForm()"
                >
                  Reset
                </b-button>
              </b-col>
            </b-row>
          </div>
        </form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BFormTextarea,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormCheckbox,
  BFormSelect,
  BFormGroup,
  BSpinner,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import api from "@/services/api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import dayjs from "dayjs";
import { decrypt } from "@/utils/crypto";
import { confirmed, required } from "vee-validate/dist/rules";

extend("confirmed", {
  ...confirmed,
  message: "Passwords do not match.",
});
extend("required", {
  ...required,
  message: "This field is required.",
});

export default {
  name: "Details",
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormTextarea,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BPagination,
    BFormCheckbox,
    BFormSelect,
    BFormGroup,
    BSpinner,
    ToastificationContent,
    BInputGroup,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      error: null,
      be_errors: {},
      form: {
        old_password: "",
        new_password: "",
        confirm_password: "",
      },
      show: {
        old: false,
        new: false,
        confirm: false,
      },
      loading: false,
      error: null,
      be_errors: {},
    };
  },
  computed: {},
  methods: {
    async handleSubmit() {
      this.be_errors = {};
      const valid = await this.$refs.formRules.validate();
      if (!valid) return;
      const loader = this.$showCustomLoader();
      try {
        // Get user_id from localStorage (adjust if you get it from elsewhere)
        const userData = decrypt(localStorage.getItem("userData"));
        const user_id = userData ? userData.u_id : null;
        if (!user_id) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "User ID not found.",
              icon: "AlertCircleIcon",
              variant: "danger",
            },
          });
          loader.hide();
          return;
        }
        const payload = {
          user_id,
          old_password: this.form.old_password,
          new_password: this.form.new_password,
          new_password2: this.form.confirm_password,
        };
        const response = await api.post("/api/v1/reset-password/", payload);
        if (response.data && response.data === "Wrong Old Password") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error!",
              text: response.data,
              icon: "AlertCircleIcon",
              variant: "danger",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Success",
              text: "Password changed successfully!",
              icon: "CheckIcon",
              variant: "success",
            },
          });
          // Optionally reset form
        }
        this.resetForm();
      } catch (err) {
        // Show backend field errors if present
        if (err.response && err.response.data) {
          this.be_errors = err.response.data;
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title:
              err.response?.data?.message || err.message || "Password change failed.",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      } finally {
        loader.hide();
      }
    },
    resetForm() {
      var _this = this;
      Object.keys(this.form).forEach(function (key, index) {
        _this.form[key] = "";
      });
      requestAnimationFrame(() => {
        this.$refs.formRules.reset();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// Style for disabled textareas
::v-deep .form-control[disabled] {
  background-color: #f8f9fa;
  opacity: 1;
  cursor: not-allowed;
}
</style>
